import WorkingHours from "./WorkingHours";

export default WorkingHours;
